import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MessageGeneralSectionSMSReuseSection from 'components/message/MessageGeneralSectionSMSReuseSection'
import MessageGeneralSectionEmailReuseSection from 'components/message/MessageGeneralSectionEmailReuseSection'
import MessageGeneralSectionInboxAndPushReuseSection from 'components/message/MessageGeneralSectionInboxAndPushReuseSection'
import MessageGeneralSectionWhatsappReuseSection from 'components/message/MessageGeneralSectionWhatsappReuseSection'
import RecurringMessagePromptTabs from 'components/campaign/campaignCreation/RecurringMessagePromptTabs'
import { MessageChannel, MessageBackendChannel } from 'config/CustomEnums'

const formFieldsMappings = {
    [MessageChannel.email]: {
        component: MessageGeneralSectionEmailReuseSection,
    },
    [MessageChannel.sms]: {
        component: MessageGeneralSectionSMSReuseSection,
    },
    [MessageChannel.whatsapp]: {
        component: MessageGeneralSectionWhatsappReuseSection,
    },
    [MessageChannel.pushAndInbox]: {
        component: MessageGeneralSectionInboxAndPushReuseSection,
    }
}

const renderTabForLanguage = ({ language, channel }) => {
    const languageCode = language.code
    const formData = formFieldsMappings[channel]
    console.log("renderTabForLanguage:", channel)
    console.log("formData:", formData)

    return {
        name: language.sourceName,
        content: <formData.component
            language={languageCode}
            isRecurringMessage
        />
    }
};

const getTabs = ({ languages, channel }) => {
    if (!languages) {
        return []
    }
    return languages.map(language => renderTabForLanguage({ language, channel }))
}

function RecurringMessagePromptBody({ channel }) {
    const languages = useSelector(state => state.language.allList)
    console.log("RecurringMessagePromptBody channel:", channel)

    const tabs = getTabs({ languages, channel })

    return (
        <RecurringMessagePromptTabs tabs={tabs} />
    )
}

export default RecurringMessagePromptBody;
